import { render } from "./DropZoneUploader.vue?vue&type=template&id=9ae284b8&scoped=true"
import script from "./DropZoneUploader.vue?vue&type=script&lang=js"
export * from "./DropZoneUploader.vue?vue&type=script&lang=js"

import "./DropZoneUploader.vue?vue&type=style&index=0&id=9ae284b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae284b8"]])

export default __exports__